import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const FinalCta = () => (
  <section className="py-16 sm:py-24" data-testid="final-cta-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="relative rounded-[2.5rem] bg-[#B9A58D]/25 border border-[#B9A58D]/40 overflow-hidden">
        <div className="px-8 py-14 sm:p-16 text-center max-w-2xl mx-auto">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#292A26] tracking-tight leading-tight" data-testid="final-cta-heading">
            Looking for someone you can trust?
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#575953]">
            Whether you are looking for a regular walking place or planning time
            away, tell Carly a little about your pet and what you need.
          </p>
          <p className="mt-4 text-sm text-[#575953]">
            Regular walking enquiries welcome for Monday, Tuesday and Friday.
            In-home sitting and other care are subject to availability.
          </p>
          <Link
            to="/contact"
            data-testid="enquire-final-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#3F4A38] text-[#F7F4ED] px-7 py-3.5 text-sm font-semibold hover:bg-[#2F382B] transition-colors"
          >
            Enquire About Availability
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
